import Ripple from 'vue-ripple-directive'
import Vue from 'vue'

Vue.use(Ripple)
Vue.directive('ripple', Ripple)
